export function safeArrayAccess<T extends NonNullable<unknown>>(array: T[], index: number, errorMessage?: string): T {
  const element = array[index];
  if (element === undefined) {
    throw new Error(errorMessage || `Array index ${index} is out of bounds or undefined`);
  }
  return element;
}
